export default {
  modalHeader: 'Ersatzteile verknüpfen',
};
